import React from "react";
import { PageLayout } from "@features/shared";
import { usePageInitialization } from "@features/shared/hooks/usePageInitialization";
import { QueryList } from "./components";

/**
 * Service Request Feature - Public API
 */

// Components
export * from "./components";

// Hooks
export * from "./hooks";

// Services
export * from "./services/serviceRequestService";

/**
 * QueriesPage - Page wrapper
 * Service request management - displays all queries/tickets
 */
export const QueriesPage = () => {
  usePageInitialization();
  return (
    <PageLayout title="Service Request" backPath="/">
      <QueryList />
    </PageLayout>
  );
};
